

import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {

  components: {
    ValidationObserver,
    ValidationProvider
  },

  data: () => {
    return {
      firstname: undefined,
      lastname: undefined,
      email: undefined,
      phone: undefined,
      topic: undefined,
      message: undefined,
      // topics: [],

      contactSubmitSnackbar: false,
      contactSubmitSnackbarText: ''
    }
  },

  methods: {

    clear () {
      this.firstname = undefined
      this.lastname = undefined
      this.email = undefined
      this.phone = undefined
      this.topic = undefined
      this.message = undefined

      this.$refs.observer.reset()
    },

    async submit () {
      const submission = {

        fields: [
          {
            name: 'email',
            value: this.email
          },
          {
            name: 'firstname',
            value: this.firstname
          },
          {
            name: 'lastname',
            value: this.lastname
          },
          {
            name: 'message',
            value: this.message
          },
          {
            name: 'TICKET.subject',
            value: 'Ihre Kontaktanfrage'
          },
          {
            name: 'TICKET.content',
            value: this.message
          }
        ]
      }

      const that = this
      const config = {}
      const instance = this.$axios.create(config)
      const response = await instance.post('https://api.hsforms.com/submissions/v3/integration/submit/9144854/f5e14fb9-a3c7-4e43-9539-9bbd7971a850', submission)
        .catch(function (error) {
          console.error(error)
          if (error.response) {
            // Request made and server responded
            that.contactSubmitSnackbarText = this.$t('contacts.error')
            that.contactSubmitSnackbar = true
          } else if (error.request) {
            // The request was made but no response was received
            //
            that.contactSubmitSnackbarText = this.$t('contacts.error')
            that.contactSubmitSnackbar = true
          } else {
            // Something happened in setting up the request that triggered an Error
            //
            that.contactSubmitSnackbarText = this.$t('contacts.error')
            that.contactSubmitSnackbar = true
          }
        })

      if (response?.status === 200) {
        this.contactSubmitSnackbarText = this.$t('contacts.success')
        this.contactSubmitSnackbar = true
        this.clear()
      } else {
        this.contactSubmitSnackbarText = this.$t('contacts.error')
        this.contactSubmitSnackbar = true
      }
      this.clear()
    }
  }

}

